module.exports = __webpack_public_path__ + "img/imge2.b8c9e321.webp";